import { BaseTable } from './BaseTable'
import { usePriceGetAgDetailsContext } from './PriceGetAgDetailsContext'

export const NetworkOperatingCostsTable = () => {
  const { getAgPriceDetails, t, tax, getAgPriceType } =
    usePriceGetAgDetailsContext()

  // base fee
  const networkBasePrice = getAgPriceDetails.breakdown.static?.['basic_fee']

  // work fee (power)
  const networkWorkPriceHT =
    getAgPriceDetails.breakdown.variable?.['power_kwh_ht']
  const networkWorkPriceNT =
    getAgPriceDetails.breakdown.variable?.['power_kwh_nt']

  // work fee (gas)
  const gasNetworkWorkPrice = getAgPriceDetails.breakdown.variable?.['grid_fee']

  return (
    <BaseTable
      rows={[
        {
          label: t(
            'getag_details_table.groups.network_operating_fees.fees.network_operating_fee_base',
            'Netzentgelt Grundpreis'
          ),
          isEmpty: !networkBasePrice?.amount,
          amountDecimal: networkBasePrice?.amount_decimal,
          tax
        },
        ...(Boolean(networkWorkPriceHT && networkWorkPriceNT) &&
        getAgPriceType === 'power'
          ? [
              // Show both HT and NT rows with proper labels
              {
                label:
                  t(
                    'getag_details_table.groups.network_operating_fees.fees.network_operating_fee_work',
                    'Netzentgelt Arbeitspreis'
                  ) + ' (HT)',
                isEmpty: !networkWorkPriceHT?.amount,
                amountDecimal: networkWorkPriceHT?.amount_decimal,
                unitAmountDecimal: networkWorkPriceHT?.unit_amount_decimal,
                tax
              },
              {
                label:
                  t(
                    'getag_details_table.groups.network_operating_fees.fees.network_operating_fee_work',
                    'Netzentgelt Arbeitspreis'
                  ) + ' (NT)',
                isEmpty: !networkWorkPriceNT?.amount,
                amountDecimal: networkWorkPriceNT?.amount_decimal,
                unitAmountDecimal: networkWorkPriceNT?.unit_amount_decimal,
                tax
              }
            ]
          : getAgPriceType === 'power'
            ? [
                // Show single work price row (HT or NT, whichever exists)
                {
                  label: t(
                    'getag_details_table.groups.network_operating_fees.fees.network_operating_fee_work',
                    'Netzentgelt Arbeitspreis'
                  ),
                  isEmpty: !(networkWorkPriceHT || networkWorkPriceNT)?.amount,
                  amountDecimal: (networkWorkPriceHT || networkWorkPriceNT)
                    ?.amount_decimal,
                  unitAmountDecimal: (networkWorkPriceHT || networkWorkPriceNT)
                    ?.unit_amount_decimal,
                  tax
                }
              ]
            : [
                {
                  label: t(
                    'getag_details_table.groups.network_operating_fees.fees.network_operating_fee_work',
                    'Netzentgelt Arbeitspreis'
                  ),
                  isEmpty: !gasNetworkWorkPrice?.amount,
                  amountDecimal: gasNetworkWorkPrice?.amount_decimal,
                  unitAmountDecimal: gasNetworkWorkPrice?.unit_amount_decimal,
                  tax
                }
              ])
      ]}
      title={t(
        'getag_details_table.groups.network_operating_fees.title',
        'Netzbetriebskosten'
      )}
    />
  )
}
